import React from 'react';
import { SettingsController } from './settingsInterface';
import { SettingsViewProps } from './settingsProps';
import { SettingsConfig } from './settingsConfig';

export function createSettingsContainer(
    config: SettingsConfig['deps'],
    controller: SettingsController,
    Component: React.FC<SettingsViewProps>
): React.FC {
    return (props) => {
        const viewProps = controller.useProps();
        return <Component {...viewProps}>{props.children}</Component>;
    };
}
